import React, { useState } from "react";
import { toast } from "sonner";
import { GraduationCap, Loader2, KeyRound } from "lucide-react";
import { api, apiError } from "../../lib/api";

export const EvalFinal = ({ evalData, onSaved, basePath = "/academia" }) => {
  const [answers, setAnswers] = useState(
    Object.fromEntries(evalData.questions.map((q) => [q.q_id, q.user_answer || ""]))
  );
  const [sending, setSending] = useState(false);
  const done = evalData.eval_done;

  const submit = async () => {
    if (evalData.questions.some((q) => !answers[q.q_id]?.trim())) {
      return toast.error(`Responde las ${evalData.questions.length} preguntas antes de enviar`);
    }
    setSending(true);
    try {
      const { data } = await api.post(`${basePath}/eval`, { answers });
      toast.success("¡Evaluación enviada! Compara tus respuestas con la clave.");
      onSaved(data);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="eval-section" className="rounded-2xl border border-yellow-400/30 bg-emerald-950/60 p-5">
      <div className="flex items-center gap-2 mb-1">
        <GraduationCap size={18} className="text-yellow-400" />
        <h2 className="font-bold text-lg text-zinc-100">Evaluación final</h2>
      </div>
      <p className="text-xs text-zinc-400 mb-4">
        Responde con tus palabras. Al enviar, verás la respuesta clave del instructor para comparar.
      </p>
      <div className="space-y-4">
        {evalData.questions.map((q, i) => (
          <div key={q.q_id} data-testid={`eval-${q.q_id}`}>
            <p className="text-sm font-semibold text-zinc-200">{i + 1}. {q.question}</p>
            <textarea
              data-testid={`eval-input-${q.q_id}`}
              value={answers[q.q_id]}
              onChange={(e) => setAnswers({ ...answers, [q.q_id]: e.target.value })}
              rows={2}
              disabled={done}
              placeholder="Tu respuesta…"
              className="mt-1.5 w-full rounded-lg bg-black/40 border border-white/15 px-3 py-2 text-sm text-white placeholder:text-zinc-500 focus:outline-none focus:border-yellow-400 disabled:opacity-70"
            />
            {done && q.key && (
              <div data-testid={`eval-key-${q.q_id}`} className="mt-1.5 flex items-start gap-2 rounded-lg bg-emerald-500/10 border border-emerald-500/30 px-3 py-2">
                <KeyRound size={13} className="text-yellow-300 mt-0.5 shrink-0" />
                <p className="text-xs text-emerald-100"><span className="font-bold">Clave del instructor: </span>{q.key}</p>
              </div>
            )}
          </div>
        ))}
      </div>
      {!done && (
        <button
          data-testid="eval-submit"
          onClick={submit}
          disabled={sending}
          className="mt-4 inline-flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-bold bg-yellow-400 text-emerald-950 hover:bg-yellow-300 disabled:opacity-50"
        >
          {sending ? <Loader2 className="animate-spin" size={15} /> : <GraduationCap size={15} />} Enviar evaluación
        </button>
      )}
      {done && <p data-testid="eval-done-msg" className="mt-4 text-sm text-emerald-300 font-semibold">✓ Evaluación completada</p>}
    </div>
  );
};
